<!-- <div class="link-component">
    <app-layout-control>
        <app-control-label top [control]="control" [caption]="caption()" />
        <input [id]="fileInputId" type="file" (change)="onFileChosen($event)" style="display:none" />
        <dx-tag-box #dx [dataSource]="dataSource()" [value]="computedValue()" [readOnly]="readonly()"
            [isValid]="isValid" [maxDisplayedTags]="1" [minSearchLength]="0" [searchEnabled]="true"
            [showMultiTagOnly]="false" [showSelectionControls]="false" displayExpr="FileName" keyExpr="FileName" [valueExpr]="'this'"
            placeholder="None" [openOnFieldClick]="false" [isValid]="isValid" [acceptCustomValue]="false" [searchEnabled]="false" (onValueChanged)="onValueChanged($event)">
            <dxi-button name="picker" location="after" [options]="selectFileOptions"/>
        </dx-tag-box>
        <app-control-supporting-text bottom [control]="control" [controlName]="caption()" [helpText]="helpText()" [isValid]="isValid" />
    </app-layout-control>
</div> -->


<input [id]="fileInputId" type="file" (change)="onFileChosen($event)" style="display:none" />
<dx-tag-box #dx [dataSource]="dataSource()" [value]="computedValue()" [readOnly]="readonly()"
    [maxDisplayedTags]="1" [minSearchLength]="0"
    [showMultiTagOnly]="false" [showSelectionControls]="false" displayExpr="FileName" keyExpr="FileName" [valueExpr]="'this'"
    placeholder="None" [openOnFieldClick]="false" [isValid]="isValid" [acceptCustomValue]="false" [searchEnabled]="false" (onValueChanged)="onValueChanged($event)">
    <dxi-button name="picker" location="after" [options]="selectFileOptions"/>
</dx-tag-box>
